import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ArrowRight",
  "use": "ArrowRight-usage",
  "viewBox": "0 0 12 20",
  "content": "<symbol viewBox=\"0 0 12 20\" id=\"ArrowRight\">\n  <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M0 3.354L6.456 10 0 16.646 2.772 19.5 12 10 2.772.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol